import type { IconData } from '@stacksjs/iconify-core'

export const cd1x1: IconData = {
  "body": "<defs><clipPath id=\"SVGjYSgKywl\"><path fill=\"#fff\" d=\"M0-88h600v600H0z\"/></clipPath></defs><g clip-path=\"url(#SVGjYSgKywl)\" transform=\"translate(0 75.1)scale(.853)\"><path fill=\"#007fff\" d=\"M0-88h800v600H0z\"/><path fill=\"#f7d618\" d=\"M36 32h84l26-84l26 84h84l-68 52l26 84l-68-52l-68 52l26-84zM750-88L0 362v150h50L800 62V-88z\"/><path fill=\"#ce1021\" d=\"M800-88L0 392v120L800 32z\"/></g>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default cd1x1
